import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BLOG_POSTS } from "../data/content";

const CATEGORIES = ["Tất cả", ...new Set(BLOG_POSTS.map(p => p.category))];

/* ── Card ── */
function BlogCard({ post, index }) {
  return (
    <Link
      to={`/blog/${post.id}`}
      className="blog-card-enter"
      style={{
        textDecoration: "none",
        display: "block",
        animationDelay: `${index * 70}ms`,
      }}
    >
      <article
        style={{
          background: "#fff",
          border: "1px solid #E4E4E7",
          borderRadius: 14,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          transition: "transform 280ms cubic-bezier(0.25,0.1,0.25,1), box-shadow 280ms cubic-bezier(0.25,0.1,0.25,1)",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = "translateY(-4px)";
          e.currentTarget.style.boxShadow = "0 16px 40px rgba(0,0,0,0.10)";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = "";
          e.currentTarget.style.boxShadow = "";
        }}
      >
        {/* Thumbnail */}
        <div style={{ height: 180, overflow: "hidden", flexShrink: 0, background: "#E8ECF0", position: "relative" }}>
          {post.thumbnail ? (
            <img
              src={post.thumbnail}
              alt={post.title}
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", transition: "transform 500ms cubic-bezier(0.25,0.1,0.25,1)" }}
              onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.05)"; }}
              onMouseLeave={e => { e.currentTarget.style.transform = ""; }}
            />
          ) : (
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48 }}>
              {post.thumbnailEmoji}
            </div>
          )}
          <span style={{
            position: "absolute", top: 10, left: 10,
            background: "#09090B", color: "#fff",
            fontSize: 9, fontWeight: 700,
            padding: "3px 8px", borderRadius: 4,
            textTransform: "uppercase", letterSpacing: "0.08em",
            fontFamily: "'Space Grotesk',sans-serif",
          }}>
            {post.category}
          </span>
        </div>

        {/* Body */}
        <div style={{ padding: "16px 16px 14px", flex: 1, display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 8 }}>
            {post.tags.slice(0, 2).map(t => (
              <span key={t} className="tag" style={{ fontSize: 10 }}>{t}</span>
            ))}
          </div>
          <h3 style={{
            fontFamily: "'Archivo',sans-serif",
            fontWeight: 700, fontSize: 14,
            color: "#09090B", lineHeight: 1.45,
            margin: "0 0 8px", flex: 1,
            display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden",
          }}>
            {post.title}
          </h3>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "auto", paddingTop: 10, borderTop: "1px solid #F4F4F5" }}>
            <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, color: "#94A3B8" }}>
              {post.date}
            </span>
            <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 11, fontWeight: 700, color: "#2563EB", display: "flex", alignItems: "center", gap: 2 }}>
              Đọc <ArrowUpRight size={12} />
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
}

/* ── Page ── */
export default function Blog() {
  const [active, setActive] = useState("Tất cả");

  const filtered = active === "Tất cả"
    ? BLOG_POSTS
    : BLOG_POSTS.filter(p => p.category === active);

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: "48px 24px 80px" }}>

      {/* Header */}
      <div className="reveal" style={{ marginBottom: 40 }}>
        <span className="section-label">Blog</span>
        <h1 style={{
          fontFamily: "'Archivo',sans-serif",
          fontWeight: 900,
          fontSize: "clamp(28px,4vw,52px)",
          color: "#09090B",
          margin: "0 0 10px",
          letterSpacing: "-0.03em",
          lineHeight: 1.05,
        }}>
          Góc nhìn về AI<br />
          <span style={{ color: "#2563EB" }}>&amp; Content</span>
        </h1>
        <p style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 15, color: "#64748B", margin: 0, maxWidth: 460, lineHeight: 1.65 }}></p>
      </div>

      {/* Filter tabs */}
      <div className="reveal reveal-delay-1" style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 36 }}>
        {CATEGORIES.map(cat => {
          const count = cat === "Tất cả" ? BLOG_POSTS.length : BLOG_POSTS.filter(p => p.category === cat).length;
          const isActive = active === cat;
          return (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              style={{
                display: "inline-flex", alignItems: "center", gap: 6,
                padding: "7px 14px",
                borderRadius: 999,
                border: isActive ? "1.5px solid #09090B" : "1.5px solid #E4E4E7",
                background: isActive ? "#09090B" : "#fff",
                color: isActive ? "#fff" : "#52525B",
                fontFamily: "'Space Grotesk',sans-serif",
                fontSize: 13, fontWeight: 600,
                cursor: "pointer",
                transition: "all 180ms cubic-bezier(0.25,0.1,0.25,1)",
              }}
              onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.borderColor = "#09090B";
                  e.currentTarget.style.color = "#09090B";
                }
              }}
              onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.borderColor = "#E4E4E7";
                  e.currentTarget.style.color = "#52525B";
                }
              }}
            >
              {cat}
              <span style={{
                fontSize: 10, fontWeight: 700,
                background: isActive ? "rgba(255,255,255,0.18)" : "#F4F4F5",
                color: isActive ? "#fff" : "#94A3B8",
                padding: "1px 5px", borderRadius: 99,
              }}>
                {count}
              </span>
            </button>
          );
        })}
      </div>

      {/* Grid */}
      <div key={active} style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: 20,
      }}>
        {filtered.map((post, i) => (
          <BlogCard key={post.id} post={post} index={i} />
        ))}
      </div>

      {filtered.length === 0 && (
        <div style={{ textAlign: "center", padding: "64px 0", fontFamily: "'Space Grotesk',sans-serif", color: "#94A3B8", fontSize: 14 }}>
          Chưa có bài viết nào trong mục này.
        </div>
      )}
    </div>
  );
}
